import { useEDTHistory } from './historyAtoms';
import { useUpdateEdtSeance } from '@teetsh/app/src/queries/edt/useUpdateEdtSeance';
import { useQueryClient } from '@tanstack/react-query';
import { EDT_KEY } from '@teetsh/app/src/queries/edt/useEDTs';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { EmploiDuTemps } from '@teetsh/app/src/types/edt';
import useDeleteEDTEvents from '@teetsh/app/src/queries/edt/useDeleteEDTEvents';
import useCreateEDTEvent from '@teetsh/app/src/queries/edt/useCreateEDTEvent';

export default function useRedoEDT(edtId: string) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { past, setPast, future, setFuture } = useEDTHistory(edtId);
  const updateEdtSeance = useUpdateEdtSeance(edtId, true);
  const removeEDTEvents = useDeleteEDTEvents(edtId, true);
  const createEDTEvents = useCreateEDTEvent(edtId, true);
  const queryClient = useQueryClient();

  return () => {
    const edt = queryClient.getQueryData<EmploiDuTemps>([
      schoolyear.id,
      school.id,
      EDT_KEY,
      edtId,
    ]);
    const [firstItem, ...restFuture] = future;
    setFuture(restFuture);
    setPast(past);
    if (edt) {
      setPast([...past, edt.events]);
    }

    const futureEvents = firstItem || [];
    const futureIds = futureEvents.map(evt => evt.id);
    const currentEvents = edt?.events || [];
    const currentIds = currentEvents.map(evt => evt.id);
    const eventsToDelete = currentEvents.filter(
      evt => !futureIds.includes(evt.id),
    );
    const eventsToCreate = futureEvents.filter(
      evt => !currentIds.includes(evt.id),
    );
    const eventsToUpdate = futureEvents.filter(evt =>
      currentIds.includes(evt.id),
    );
    return Promise.all([
      removeEDTEvents(eventsToDelete.map(evt => evt.id)),
      ...eventsToUpdate.map(evt => updateEdtSeance(evt)),
      ...eventsToCreate.map(evt => createEDTEvents(evt)),
    ]);
  };
}
